/**
 * ローディングON/OFF
 */
import { mapMutations } from 'vuex';
export const loadingMixin = {
  methods: {
    ...mapMutations(['$_setLoading']),
  },
};
